import { useMemo } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import EpisodeCard from "@/components/feature/EpisodeCard";
import { episodes } from "@/mocks/episodes";

export default function LatestEpisodes() {
  const latest = useMemo(() => {
    return [...episodes]
      .sort((a, b) => (a.airDate < b.airDate ? 1 : -1))
      .slice(0, 8);
  }, []);

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 bg-background-100">
      <SectionHeading
        eyebrow="最新上线"
        title="最新剧集"
        description="按首播时间更新的剧集列表，点击卡片即可进入对应分集详情，查看本集剧情与更多内容。"
        actionLabel="查看全部剧集"
        actionTo="/category"
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {latest.map((episode) => (
          <EpisodeCard key={episode.id} episode={episode} />
        ))}
      </div>
    </section>
  );
}